import { extendTheme } from 'native-base'

import { DESIGN_SYSTEM_THEME } from '../../constants/config'

import prosperia from './partners/prosperia'

export type Theme = 'prosperia'

type ThemeType = Record<Theme, typeof prosperia>

const theme: ThemeType = {
  prosperia,
}

// TODO: Check the use of dynamic import here.
export default extendTheme(theme[DESIGN_SYSTEM_THEME] || theme.prosperia)
